import React from "react";
import styled from "styled-components";

const StyledCoursePreview = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr auto;
  grid-column-gap: 20px;
  padding: 10px;
  box-shadow: 0px 0px 10px 6px rgba(0, 0, 0, 0.16);
  margin-bottom: 1rem;
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    display: block;
  }

  .courseImage {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .courseSummary {
    .courseTitle {
      font-size: 20px;
    }
  }
  .courseLink {
    width: 125px;
    height: 45px;
    line-height: 43px;
    text-align: center;
    color: ${(props) => props.theme.primaryBlue};
    border: 1px solid ${(props) => props.theme.primaryBlue};
    transition: all 200ms ease-out;
    &:hover {
      color: white;
      background: ${(props) => props.theme.primaryBlue};
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      display: block;
    }
  }
`;

const CoursePreview = ({
  courseId,
  courseImage,
  courseTitle,
  courseDescription,
  children,
}) => {
  return (
    <StyledCoursePreview>
      <div className="courseImage">
        <img src={courseImage} alt="" />
      </div>
      <div className="courseSummary">
        <h2 className="courseTitle">{courseTitle}</h2>
        <p className="courseDescription standardCopy">{courseDescription}</p>
      </div>
      {children}
    </StyledCoursePreview>
  );
};

export default CoursePreview;
